import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  Button,
} from 'components';
import { GeneralService, ServiceService } from 'services';
import { CheckWhiteIcon, DeleteIcon, EditIcon } from 'assets/icons';
import ModalCreate from './calling-create';
import { data } from 'jquery';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {}

class CallingService extends React.Component<Props> {
  state = {
    areas: [],
    data: [],
    type: '',
    visible: false,
    addNew: false,
    item: null,
  };

  componentDidMount() {
    this.load();
    this.getSelects();
  }

  load = async () => {
    const { user } = this.props;
    const { type } = this.state;

    if (!user || !type) return;

    const res: any = await ServiceService.calling.get({
      user_id: user?.id,
      area_id: type,
      withoyldLoading: true,
    });

    if (res.every((i: any) => i.hours.length === 0)) {
      this.setState({
        addNew: true,
      });
    } else {
      this.setState({
        addNew: false,
      });
    }

    this.setState({
      data: res,
    });
  };

  getSelects = async () => {
    const { user } = this.props;
    const res: any = await GeneralService.getSelects({
      user_id: user?.id,
      lawyer_areas: true,
    });
    this.setState({
      areas: res?.areas.map((x: any) => x.area),
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(),
    );
  };

  open = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  deleteDay = (item: any) => {
    Globals.confirm(
      '¿Desea eliminar la programación de llamadas?',
      async () => {
        try {
          await ServiceService.calling.delete({
            user_id: this.props.user?.id,
            area_id: this.state.type,
            week_day: item.week_day,
          });
          Globals.showSuccess('Horario eliminado correctamente');
          this.load();
        } catch (error) {}
      },
    );
  };

  render() {
    const { visible, addNew, item } = this.state;

    return (
      <div id="calling-services">
        <Modal
          className="modal-create-user"
          visible={visible}
          size="xl"
          title={
            this.state.item
              ? `Asignar horario para el ${(item as any)?.day_text}`
              : 'Asignar horario'
          }
          onClose={() => this.onClose()}
        >
          {/* @ts-ignore */}
          <ModalCreate
            onClose={() => this.onClose()}
            area_id={this.state.type}
            item={this.state.item}
          />
        </Modal>

        <p className="title">Configurar llamadas telefónicas</p>

        <p className="subtitle">
          Tipo de derecho a atender mediante la llamada
        </p>
        <p className="text">(Seleccione el (los) tipo(s) de derecho(s))</p>

        <Select
          name="type"
          color="white"
          className="select"
          placeholder="Tipo de derecho"
          value={this.state.type}
          onChange={(e: any) => {
            this.setState({ type: e.target.value }, () => this.load());
          }}
          options={this.state.areas.map((item: any) => {
            return {
              value: item.id,
              label: item.name,
            };
          })}
        />

        <p className="subtitle">Programar calendarios de llamadas</p>
        <p className="text">
          (Seleccione dia(s) y hora(s) para atender llamadas)
        </p>

        {this.state.type && (
          <>
            {addNew && (
              <button onClick={(e: any) => this.open(e, null)} className="btn">
                Asignar horario
              </button>
            )}

            <section className="schedule-container">
              {this.state.data.map((item: any) => {
                const hours =
                  item?.hours?.length > 0 ? JSON.parse(item.hours) : [];
                return (
                  <div className="schedule-item" key={item.id ?? item.week_day}>
                    <div className="schedule-day">
                      <img
                        src={EditIcon}
                        alt="Edit icon"
                        onClick={(e: any) => this.open(e, item)}
                      />
                      {!!hours?.length && (
                        <img
                          src={DeleteIcon}
                          className="delete"
                          alt="Delete icon"
                          onClick={() => this.deleteDay(item)}
                        />
                      )}
                      <span>{item.day_text}</span>
                    </div>
                    <span className="schedule-time">
                      {hours.map((timeRange: any, index: number) => (
                        <React.Fragment key={index}>
                          {moment(timeRange[0], 'HH:mm').format('hh:mm A')} a{' '}
                          {moment(timeRange[1], 'HH:mm').format('hh:mm A')}
                          {index < hours.length - 1 && ' - '}
                        </React.Fragment>
                      ))}
                    </span>
                  </div>
                );
              })}
            </section>
          </>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(CallingService);
